import { Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Stepper } from './Stepper';
import { useOnboardingStore } from '@/lib/stores/onboarding';

export function OnboardingShell() {
  const { t } = useTranslation('onboarding');
  const currentStep = useOnboardingStore((s) => s.currentStep);

  return (
    <div className="min-h-dvh bg-parchment flex flex-col">
      {/* Top bar */}
      <header className="border-b border-linen bg-white/80 backdrop-blur-sm sticky top-0 z-20">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-4">
          <div className="font-display font-medium text-lg text-forge leading-none">
            tradecraft<sup className="text-copper text-xs ml-0.5 font-sans">AI</sup>
          </div>
          <Stepper currentStep={currentStep} />
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 flex flex-col items-center px-4 sm:px-6 py-8 sm:py-12">
        <div className="w-full max-w-2xl">
          <div className="mb-8 text-center">
            <h1 className="font-display text-display-md text-forge mb-2 text-balance">
              {t('title')}
            </h1>
            <p className="text-steel text-sm">{t('subtitle')}</p>
          </div>

          <Outlet />
        </div>
      </main>
    </div>
  );
}
